module.exports = __webpack_public_path__ + "static/img/youngIcon1.f822de86.png";